import "./App.css";
import { useEffect, useState, useLayoutEffect } from "react";
import { ContextApp } from "./shared/ContextApp";
import { AuthenticationService } from "./services/AuthenticationService";
import Layout from "./components/layout/Layout";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import { Product } from "./components/Product/Product";
import { Cart } from "./components/Cart/Cart";
import { Address } from "./components/Address/Address";
import { useLazyQuery } from "@apollo/client";
import { VERIFY_SESSION } from "./services/graphql/query/User";
import { User } from "firebase/auth";
import { Pay } from "./components/Pay/Pay";
import { PayFailure } from "./components/PayFailure/PayFailure";
import { PaySuccess } from "./components/PaySuccess/PaySuccess";
import { Collections } from "./components/Collections/Collections";
import { Collection } from "./components/Collection/Collection";
import { Buys } from "./components/Buys/Buys";
import LayoutAdmin from "./components/layoutAdmin/Layout";
import { Products } from "./components/Administration/Products/Products";
import { CollectionAdmin } from "./components/Administration/Collections/CollectionAdmin";
import { Sales } from "./components/Administration/Sales/Sales";
import { PayPending } from "./components/PayPending/PayPending";
import { Consultation } from "./components/Administration/Consultation/ConsultationAdmin";
import { Favorites } from "./components/Favorites/Favorites";
import { Contact } from "./components/Contact/Contact";

declare global {
  interface Window {
    MercadoPago: any;
  }
}
function App({ component: Component, rest }: any) {
  const [user, setUser] = useState<
    (User & { address?: []; role: string; id: number }) | undefined
  >();
  const [addressIdForBuy, setAddressIdForBuy] = useState<number>();
  const [verifySession] = useLazyQuery(VERIFY_SESSION);

  const { logout } = AuthenticationService();

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify({ ...user }));
    }
  }, [user]);

  useLayoutEffect(() => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("token") !== null
    ) {
      verifySession({})
        .then((data) => {
          console.log(data);
          if (data.error) {
            if (data.error.message === "Unauthorized") {
              logout();
            }
          }
        })
        .catch((error) => {});
    }
    const storage_user = localStorage.getItem("user");
    setUser(storage_user ? JSON.parse(storage_user) : undefined);
  }, []);

  return (
    <>
      <ContextApp.Provider
        value={{
          user,
          setUser,
          addressIdForBuy,
          setAddressIdForBuy,
        }}
      >
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/address" element={<Address />} />
            <Route path="/pay" element={<Pay />} />
            <Route path="/paySuccess" element={<PaySuccess />} />
            <Route path="/payFailure" element={<PayFailure />} />
            <Route path="/payPending" element={<PayPending />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collection/:id" element={<Collection />} />
            <Route path="/buys" element={<Buys />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/administration" element={<LayoutAdmin />}>
            <Route index element={<Products />} />
            <Route
              path="/administration/adminCollections"
              element={<CollectionAdmin />}
            />
            <Route path="/administration/sales" element={<Sales />} />
            <Route
              path="/administration/adminConsultation"
              element={<Consultation />}
            />
          </Route>
        </Routes>
      </ContextApp.Provider>
    </>
  );
}

export default App;
